var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":"Palo Alto Network Store"}},[_c('img',{attrs:{"src":require("assets/logo-small.png"),"alt":"Palo Alto Network Items Store"}})])
}]

export { render, staticRenderFns }